import React, { useState } from "react";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";

const snackbarStyle = {
  maxWidth: "800px",
  width: "90%",
};

const AlertStyle = {
  fontSize: "1.1rem",
  padding: "20px 24px",
  "& .MuiAlert-message": {
    fontSize: "1.1rem",
    lineHeight: "1.5",
  },
  "& .MuiAlert-icon": {
    fontSize: "1.5rem",
  },
  "& .MuiAlert-action": {
    "& .MuiIconButton-root": {
      fontSize: "1.2rem",
    },
  },
};

const ForbiddenNotification = () => {
  const [open, setOpen] = useState(true);

  return (
    <Snackbar
      key={`snackbar-forbidden`}
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      sx={snackbarStyle}
    >
      {open ? (
        <Alert
          elevation={6}
          variant="filled"
          severity={"warning"}
          onClose={() => {
            setOpen(false);
          }}
          key={"forbidden-alert"}
          sx={AlertStyle}
        >
          {
            "Thank you for creating an IDX account. Please reach out to support@vectech.io and include your name and affiliation for authorization to access the dashboard. Please allow up to 24 hours for approval."
          }
        </Alert>
      ) : null}
    </Snackbar>
  );
};

export default ForbiddenNotification;
